module.exports = __webpack_public_path__ + "img/04-title.d8e847f0.png";